import consola from 'consola';
import { fetchPage } from '@drapejs/core';
import { defineReceiver } from '@drapejs/invoker';
import { batch } from '@motillo/drapejs-litium';
import { gql } from 'graphql-request';
import axios from 'axios';
import setCookieParser from "set-cookie-parser"

export const scheduleFetchPageReceiver = defineReceiver(
  fetchPage,
  async function (command, data) {
    const page = await this.cache.getItem((<any>command).fetchFromCacheKey || (<any>command).cacheKey);

    if (!(<any>command).fetchFromCacheKey || ((<any>command).fetchFromCacheKey && !(await this.cache.getItem((<any>command).fetchFromCacheKey)))) {
      await this.invoke(batch.scheduleQuery, {
        query: gql`page(path: $path) {
        systemId
        type: template
        blocks
        fields
        dataJson {
          dataJson
        }
        canonical
        http_location: redirectUrl
        robots
        http_status: statusCode
        title
      }`,
        cacheKey: (<any>command).fetchFromCacheKey || (<any>command).cacheKey,
        variables: {
          path: {
            type: 'String!',
            value: (<any>command).path
          }
        }
      });
      console.log(`Fetching page data for key '${(<any>command).cacheKey}' from Litium`);
    } else {
      console.log(`Fetched page data for page '${(<any>command).fetchFromCacheKey}' from CACHE`);
    }

    if (!page) {
      await batch.batchQuery(this.cache, (<any>command).url, command.headers);
      const result = await this.cache.getItem((<any>command).cacheKey + ':res');
      const cookies = result ? setCookieParser.parse(result.headers?.get("set-cookie") ?? {}, {
        decodeValues: true  // default: true
      }) : {};

      if (cookies.length > 0) {
        const newCookieHeader = cookies.map(x => `${x.name}=${decodeURIComponent(x.value)}`).join("; ");
        command.headers = {
          ...(command.headers ?? {}),
          Cookie: newCookieHeader,
        };
      }
    }

    return await this.cache.getItem((<any>command).fetchFromCacheKey || (<any>command).cacheKey);
  },
  'litium'
);
